import {
  GET_INTENT_TYPES_SUCCESS,
  GET_RESOLVED_SALES_CHATS_STARTED,
  GET_RESOLVED_SALES_CHATS_SUCCESS
} from '../actions/actionTypes'

export default function aiTraining(
  state = {
    resolvedThreadsLoading: null,
    resolvedThreads: {},
    intentTypes: {}
  },
  action
) {
  switch (action.type) {
    case GET_INTENT_TYPES_SUCCESS:
      return {
        ...state,
        intentTypes: action.payload.reduce((prev, curr) => {
          return { ...prev, [curr.id]: curr }
        }, {})
      }

    case GET_RESOLVED_SALES_CHATS_STARTED:
      return {
        ...state,
        resolvedThreadsLoading: true
      }

    case GET_RESOLVED_SALES_CHATS_SUCCESS:
      return {
        ...state,
        resolvedThreadsLoading: false,
        resolvedThreads: action.payload.reduce(
          (p, c) => ({
            ...p,
            [c.chatId]: {
              ...(state.resolvedThreads[c.chatId] ? state.resolvedThreads[c.chatId] : {}),
              ...c,
              messages: state.resolvedThreads[c.chatId]
                ? state.resolvedThreads[c.chatId].messages
                : []
            }
          }),
          {}
        )
      }

    default:
      return state
  }
}
